import { apiClient } from '@/lib/apiClient';

export interface UserEmailSettingsSummary {
  host: string;
  port: number;
  username: string;
  fromName: string | null;
  starttls: boolean;
  passwordMask: string;
  lastProbeAt: string | null;
  lastProbeStatus: string | null;
  lastProbeError: string | null;
}

export interface UserEmailSettingsUpsertRequest {
  host: string;
  port: number;
  username: string;
  password: string;
  fromName?: string | null;
  starttls: boolean;
}

export interface ProbeResponse {
  ok: boolean;
  externalMessageId?: string;
  message?: string;
  error?: string;
  detail?: string;
}

export async function fetchMyEmailSettings(): Promise<UserEmailSettingsSummary | null> {
  try {
    const { data, status } = await apiClient.get<UserEmailSettingsSummary>('/me/email-settings');
    if (status === 204) return null;
    return data;
  } catch (err: unknown) {
    if (
      err &&
      typeof err === 'object' &&
      'response' in err &&
      (err as { response?: { status?: number } }).response?.status === 204
    ) {
      return null;
    }
    throw err;
  }
}

export async function saveMyEmailSettings(
  req: UserEmailSettingsUpsertRequest,
): Promise<UserEmailSettingsSummary> {
  const { data } = await apiClient.put<UserEmailSettingsSummary>('/me/email-settings', req);
  return data;
}

export async function deleteMyEmailSettings(): Promise<void> {
  await apiClient.delete('/me/email-settings');
}

export async function sendMyEmailProbe(
  to?: string,
  subject?: string,
  body?: string,
): Promise<ProbeResponse> {
  const { data } = await apiClient.post<ProbeResponse>('/me/email-settings/test', {
    to,
    subject,
    body,
  });
  return data;
}
